import type { TourConfig } from './types';

export const sidebarTour: TourConfig = {
  id: 'sidebar-navigation',
  name: 'Navigation Tour',
  description: 'Learn how to navigate the application',
  requiredPath: '/dashboard',
  steps: [
    {
      element: '[data-tour="sidebar-nav"]',
      popover: {
        title: 'Main Navigation',
        description:
          'This is your main navigation menu. Use it to access all features of NutriCRM.',
        side: 'right',
        align: 'start',
      },
    },
    {
      element: '[data-tour="nav-leads"]',
      popover: {
        title: 'Leads',
        description:
          'Manage your leads here. Track prospects from first contact to conversion.',
        side: 'right',
        align: 'center',
      },
    },
    {
      element: '[data-tour="nav-clients"]',
      popover: {
        title: 'Clients',
        description:
          'View and manage all your active clients, their diet plans, vitals, and subscriptions.',
        side: 'right',
        align: 'center',
      },
    },
    {
      element: '[data-tour="nav-counselling"]',
      popover: {
        title: 'Counselling',
        description:
          'Track first consultation sessions and follow-ups with your clients.',
        side: 'right',
        align: 'center',
      },
    },
    {
      element: '[data-tour="nav-food-database"]',
      popover: {
        title: 'Food Database',
        description:
          'Manage your food items with nutrition information for building diet plans.',
        side: 'right',
        align: 'center',
      },
    },
    {
      element: '[data-tour="nav-diet-templates"]',
      popover: {
        title: 'Diet Templates',
        description:
          'Create reusable 7-day diet plan templates to apply to multiple clients.',
        side: 'right',
        align: 'center',
      },
    },
    {
      element: '[data-tour="nav-lead-forms"]',
      popover: {
        title: 'Lead Forms',
        description:
          'Create embeddable lead capture forms for your website to automatically collect new leads.',
        side: 'right',
        align: 'center',
      },
    },
    {
      element: '[data-tour="nav-content"]',
      popover: {
        title: 'Content Management',
        description:
          'Manage banners, transformation stories, and other content for your mobile app.',
        side: 'right',
        align: 'center',
      },
    },
    {
      element: '[data-tour="nav-reports"]',
      popover: {
        title: 'Reports',
        description: 'View analytics and reports about your practice.',
        side: 'right',
        align: 'center',
      },
    },
    {
      element: '[data-tour="nav-settings"]',
      popover: {
        title: 'Settings',
        description:
          'Manage your organization settings, users, roles, and integrations.',
        side: 'right',
        align: 'center',
      },
    },
  ],
};
